import { signIn, SignInAuthorizationParams } from 'next-auth/react';
import { useCallback } from 'react';

import { useMetrics } from './useMetrics';

type SignInProps = {
  provider?: string;
  callbackUrl?: string;
  authParams?: SignInAuthorizationParams;
};
function useSignIn() {
  const metrics = useMetrics();

  const signin = useCallback(
    async (props?: SignInProps) => {
      // Keep this in mixpanel due to funnel building
      metrics.logEvent(
        'Login',
        {
          sourcePage: window.location.pathname,
          provider: props?.provider ?? 'azure-ad-b2c',
        },
        true,
      );
      const currentUrl = window.location.href;
      if (props) {
        await signIn(
          props.provider ? props.provider : 'azure-ad-b2c',
          {
            callbackUrl: props.callbackUrl
              ? props.callbackUrl
              : currentUrl
              ? currentUrl
              : '/',
          },
          props.authParams,
        );
      } else {
        await signIn('azure-ad-b2c', {
          callbackUrl: currentUrl ? currentUrl : '/',
        });
      }
    },
    [metrics],
  );

  return {
    signIn: signin,
  };
}

export default useSignIn;
